import Axios from "axios";

export type VisitConsentPageContentDto = {
  title: string;
  subtitle: string;
  description: string;
};

export type VisitConsentDocumentDto = {
  id: string;
  order: number;
  title: string;
  description: string;
  body: string;
  fileName: string | null;
  fileViewerUrl: string | null;
};

export type VisitConsentVisitContextDto = {
  visitId: number;
  startDate: string;
  endDate: string;
  locationName: string;
  visitorName: string | null;
};

export type VisitConsentByTokenResponse = {
  linkType: "visitor" | "admin";
  consentStatus: "pending" | "complete";
  companyLogoUrl?: string | null;
  content: VisitConsentPageContentDto;
  documents: VisitConsentDocumentDto[];
  visit: VisitConsentVisitContextDto;
};

export type VisitConsentConfirmResponse = {
  consentStatus: "complete";
  alreadyComplete: boolean;
};

/** Load public visitor consent session for a magic-link token (cold browser tab). */
export const getVisitConsentByToken = (token: string) =>
  Axios.get<VisitConsentByTokenResponse>(`/visit/consent/by-token/${encodeURIComponent(token)}`);
